import React from 'react';

import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from "./components/pages/Home";
import Contact from "./components/pages/Contact";
import About from "./components/pages/About";

import Student from "./components/pages/Student";
// import Uploadfile from "./components/pages/Uploadfile";

import Webbook from './components/pages/Webbook';
import Footer from './components/inc/Footer';
import Career from './components/pages/Career';
import Distributor from './components/pages/Distributor';
import Ourdevelop from './components/pages/Ourdevelop';

import Contactform from './components/pages/Contactform';
import BookAppoint from './components/pages/BookAppoint';
import Blog from './components/pages/Blog';
import Websitedevelopment from './components/pages/Websitedevelopment';
import Support from './components/pages/Support';
import Balajisaree from './components/pages/Balajisaree';
import Gpautokrishnagar from './components/pages/Gpautokrishnagar';
import Misaa from './components/pages/Misaa';
import Mak from './components/pages/Mak';
import Rupaecobrick from './components/pages/Rupaecobrick';
import Mbdhar from './components/pages/Mbdhar';
import Websitetalk from './components/pages/Websitetalk';
import Businesstalk from './components/pages/Businesstalk';






function App() {
  return (
    <Router>

      <div>



        <Routes>

          <Route axact path="/" element={<Home />} />
          <Route axact path="/Contact" element={<Contact />} />
          <Route axact path="/about" element={<About />} />



          <Route axact path="/Student" element={<Student />} />
          {/* <Route axact path="/Uploadfiles" element={<Uploadfile/>}/> */}

          <Route axact path="/website-book" element={<Webbook />} />



          <Route axact path="/Career" element={<Career />} />
          <Route axact path="/franchise" element={<Distributor />} />
          <Route axact path="/our-development" element={<Ourdevelop />} />

          <Route axact path="/booknow" element={<BookAppoint />} />

          <Route path="/Website_book" element={<Contactform />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/website-development" element={<Websitedevelopment />} />
          <Route path="/Maintenance-Support" element={<Support />} />
          <Route path="/balajisaree" element={<Balajisaree />} />
          <Route path="/gppremia-krishnagar" element={<Gpautokrishnagar />} />
          <Route path="/misaa" element={<Misaa />} />
            <Route path="/mak" element={<Mak/>} />
             <Route path="/blog-rupaecobrick" element={<Rupaecobrick/>} />
             <Route path="/mbdharandsonjewellers" element={<Mbdhar/>} />
              <Route path="/talktoawebsite_debvelopment" element={<Websitetalk/>} />
                <Route path="/Businesstalk" element={<Businesstalk/>} />
        </Routes>

        <Footer />
      </div>

    </Router>
  );
}

export default App;